export const officeSettingsTabList = [
  {
    label: "Operational",
    link: "/admin/settings/office-settings",
  },
  {
    label: "Attendance",
    link: "/admin/settings/office-settings/attendance",
  },
  {
    label: "Shift",
    link: "/admin/settings/office-settings/shift",
  },
  {
    label: "Leave",
    link: "/admin/settings/office-settings/leave",
  },
  {
    label: "Holiday",
    link: "/admin/settings/office-settings/holiday",
  },
  // {
  //   label: "Notification",
  //   link: "/admin/settings/office-settings/notification",
  // },
  {
    label: "Change Log",
    link: "/admin/settings/office-settings/change-log",
  },
];
